import { sanitizeHtml } from '@/utils/safeHtml';

function applySafeHtml(el, value) {
  if (!el) return;
  // innerHTML em nó ainda desconectado é válido; o guard isConnected no
  // beforeMount impedia a pintura inicial (aba Texto ficava vazia até um
  // updated posterior — que nem sempre ocorre).
  el.innerHTML = sanitizeHtml(value);
}

export const vSafeHtml = {
  /**
   * Prefere `mounted` (elemento já no documento) em vez de só `beforeMount`,
   * onde `el.isConnected` costuma ser false e a aplicação era ignorada.
   */
  mounted(el, binding) {
    applySafeHtml(el, binding.value);
  },
  updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    applySafeHtml(el, binding.value);
  },
};
